import type { RenderComponentProps } from "replo-runtime/shared/types";

import React from "react";

import { useBundleBuilder } from "../BundleBuilderContext";

export const BundleProgressBar: React.FC<RenderComponentProps> = ({
  componentAttributes,
  component,
}) => {
  const { getBundleTotalQuantity, selectedBundleDiscountThreshold } =
    useBundleBuilder();
  const backgroundColor = component.props?.style?.color ?? "#1E293B";
  const total = getBundleTotalQuantity();
  const target = selectedBundleDiscountThreshold.quantity;
  const progress = Math.min(100, (total / target) * 100);
  return (
    <div
      {...componentAttributes}
      style={{
        marginBottom: "24px",
      }}
    >
      <h3
        style={{
          margin: "0 0 16px 0",
        }}
      >
        {total}/{target} Items Added
      </h3>

      <div
        style={{
          width: "100%",
          height: "12px",
          backgroundColor: "#e1e1e1",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "block",
            width: `${progress}%`,
            height: "100%",
            backgroundColor: backgroundColor,
            transition: "width 0.3s ease",
          }}
        />
      </div>
    </div>
  );
};
